export default {
  settingAuthorize: {
    header: {
      name: 'Logistics Provider Name',
      business: 'Logistics Business Name',
      type: 'Interface Type',
      channel: 'Platform Type',
    },

    authorized: 'Logistics Authorization Configuration',

    table: {
      name: 'Logistics Provider Name',
      business: 'Logistics Business Name',
      type: 'Interface Type',
      channel: 'Platform Type (Channel)',
      obtain: 'Automatically Obtain',
      default: 'Default Setting',
      warehouse: 'Use Warehouse',
      template: 'Shipping Label Template',
      linkMan: 'Shipping Label Contact Person',
      phone: 'Shipping Label Contact Mobile',
      address: 'Shipping Label Address',
    },

    addAndEdit: {
      title: 'Logistics Authorization Configuration',
      authorized: 'Authorization Configuration',
      logistics: 'System Logistics Provider',
      business: 'System Logistics Business',
      logisticsText: 'Please select the associated logistics provider first',
      interface: 'Interface Type',
      channel: 'Platform Type (Channel)',
      authorizeTitle: 'Use store account authorization',
      defaultType: 'Set as default interface type',
      shipment: 'Enable automatic obtaining of logistics tracking number',
      useWarehouse: 'Use Warehouse',
      addWarehouse: 'Add Warehouse',
      interfaceMsg: 'Interface Information',
      tooltipText: 'When obtaining the tracking number, match the order platform type first, and use the default interface type if there is no match.',

      table: {
        warehouseCode: 'Warehouse code',
        warehouseName: 'Warehouse name',
        code: 'Network code',
        name: 'Network name',
        cardNumber: 'Credit card number',
        address: 'Shipping address',
        electronicForm: 'Available number of electronic waybill',
        defaultAddress: 'Default address',
        business: 'Logistics service type',

      },

      print: 'Printing configuration',
      downloadPrint: 'Download printing component',
      standardTemplate: 'Cloud printing standard template',
      selectStandardTemplate: 'Please select a cloud printing standard template',
      printTemplate: 'Cloud printing custom template',
      sender: 'Sender information on waybill',
      sendMobile: "Sender's mobile number on waybill",
      sendAddress: "Sender's address on waybill",
      addressText: 'Please enter detailed address',
      address: 'Detailed address',
      tips: "Please ensure that the shipping address you enter is consistent with the one in your store's backend to prevent any failure to obtain a waybill.",
      rulesLogisticsCompany: 'Please select a system logistics provider',
      rulesLogisticsBusiness: 'Please select a system logistics service',
      rulesInterfaceType: 'Please select an interface type',
      rulesChannelList: 'Please select a platform category (channel)',
      rulesShop: 'Please select to authorize with store account',
      rulesSender: 'Please select the sender information on waybill',
      rulesSendMobile: "Please enter the sender's mobile number on waybill",
      rulesCallback1: 'Please select province/city/district',
      rulesCallback2: 'Please enter detailed address',
      msgError: 'Please select a warehouse to use'
    }
  }
};
